import { useEffect, useState } from 'react'
import {
  CuraButton,
  CuraHeading,
  CuraModal,
  CuraParagraph
} from '@rededor/cura-react'

import { Address } from '@/models/domain/Address'
import { Bold } from '@/shared/styles/styled-elements'
import { sendEvent } from '@/services/mixPanelService'
import { IconDate } from '@/components/IconDate'
import * as S from './styles'

export const UnitNearbyPrivate = ({ unit, onClick }) => {
  const [showPrivatePaymentModal, setShowPrivatePaymentModal] = useState(false)
  const address = new Address({
    street: unit?.street,
    number: unit?.number,
    complement: unit?.complement,
    neighborhood: unit?.neighborhood,
    city: unit?.city,
    state: unit?.state,
    zipCode: unit?.zipCode
  }).buildFormattedAddress()

  const actionButtonStyle = {
    width: '100%'
  }

  const sendEventModalAction = (buttonLabel: 'FECHAR' | 'CONTINUE') => {
    sendEvent({
      eventName: 'MODAL_FALLBACK_PRIVATE_SUGGESTION',
      data: {
        MODAL_FALLBACK_PRIVATE_SUGGESTION: true,
        BUTTON_PRIVATE: buttonLabel === 'CONTINUE',
        BUTTON_CLOSE: buttonLabel !== 'CONTINUE'
      }
    })
  }

  const handleClickSuggestion = () => {
    setShowPrivatePaymentModal(true)
  }

  const handleCloseModal = () => {
    sendEventModalAction('FECHAR')
    setShowPrivatePaymentModal(false)
  }

  const handleContinueWithPrivatePayment = () => {
    sendEventModalAction('CONTINUE')
    onClick()
  }

  useEffect(() => {
    return () => {
      setShowPrivatePaymentModal(false)
    }
  }, [])

  return (
    <>
      <S.WrapperUnitNearbyPrivate>
        <S.WrapperTitleUnitNearbyPrivate>
          <S.TitleUnitNearbyPrivate>
            <CuraHeading size="small" color="neutral-dark" marginBlock="0">
              Atendimento particular
            </CuraHeading>
          </S.TitleUnitNearbyPrivate>
        </S.WrapperTitleUnitNearbyPrivate>
        <S.ContentUnitNearbyPrivate onClick={handleClickSuggestion}>
          <IconDate date={unit.earliestDate} />
          <div>
            <CuraHeading
              size="xsmall"
              color="primary"
              weight="bold"
              marginBlock="0"
            >
              {unit.name}
            </CuraHeading>
            <CuraParagraph color="neutral-dark" size="small" marginBlock="0">
              <S.TruncateAddress>{address}</S.TruncateAddress>
            </CuraParagraph>
          </div>
        </S.ContentUnitNearbyPrivate>
      </S.WrapperUnitNearbyPrivate>
      <CuraModal open={showPrivatePaymentModal} onModalClose={handleCloseModal}>
        <S.ContentModalUnitNearbyPrivate>
          <CuraHeading size="medium" color="primary">
            <Bold $weight="medium">
              Deseja agendar uma consulta particular?
            </Bold>
          </CuraHeading>
          <CuraParagraph size="medium" color="neutral-black" marginBlock="24px">
            Ao continuar, você verá horários e valores para agendamento
            particular (consulta paga).
          </CuraParagraph>
          <CuraButton
            size="medium"
            fontColor="light"
            onClick={handleContinueWithPrivatePayment}
            style={actionButtonStyle}
          >
            CONTINUE
          </CuraButton>
        </S.ContentModalUnitNearbyPrivate>
      </CuraModal>
    </>
  )
}
